<script lang="ts">
	export let click: () => void
	export let selected: boolean = false
	export let level: number = 0
</script>

<li
	class="nav-item hover:text-white w-full transition-color duration-100 hover:bg-blue-400"
	class:selected={selected}
	on:click={click}
>
	<span class:level1={level === 1}></span>
	<slot></slot>
</li>

<style lang="postcss">
	.nav-item {
		min-height: 45px;
		@apply flex items-center px-4 mb-1 text-sm font-medium rounded-md cursor-pointer;
	}

	.selected {
		@apply bg-blue-400 text-white;
	}

	.level1 {
		@apply ml-7;
	}
</style>